import React, { useEffect, useRef } from 'react';
import { insuranceNetworkSearch } from '../utils/prop-types';
import cx from 'classnames';
import { debounce } from 'lodash';
import { CloseIcon } from '../../icons/index';
import styles from '../styles.module.scss';

const InsuranceNetworkSearch = ({
                                  roles,
                                  searchValue,
                                  setSearchValue,
                                  showCreateForm,
                                  setShowCreateForm,
                                  insuranceNetworks,
                                  setCurrentInsuranceNetworks,
                                  setSelectedInsuranceNetwork
                                }) => {
  const debouncedSearch = useRef(null);

  useEffect(() => {
    debouncedSearch.current = debounce(() => search(), 500);
    debouncedSearch.current();

    return () => {
      debouncedSearch.current.cancel();
    }
  }, [searchValue]);

  const search = () => {
    if (searchValue) {
      const lowerCaseName = searchValue.toLowerCase().trim();
      const currentInsuranceNetworks = insuranceNetworks.filter(
        insuranceNetwork => insuranceNetwork.name.toLowerCase().includes(lowerCaseName)
      );
      setCurrentInsuranceNetworks(currentInsuranceNetworks);
    } else {
      clearSearch();
    }
  };

  const clearSearch = () => {
    setSearchValue('');
    setCurrentInsuranceNetworks(insuranceNetworks);
  };

  const toggleInsuranceNetworkCreateForm = () => {
    setShowCreateForm(!showCreateForm);
    setSelectedInsuranceNetwork(null);
  };

  return (
    <div className={styles.formSearch}>
      <div className={styles.form}>
        <div className={styles.field}>
          <div>
            <label>Search</label>
          </div>
          <div className={styles.fieldSearch}>
            <input
              type='text'
              placeholder='Enter name'
              value={searchValue}
              onChange={event => setSearchValue(event.target.value)}
            />
            {
              searchValue &&
              <a onClick={() => clearSearch()}>
                <CloseIcon width={15} height={15} />
              </a>
            }
          </div>
        </div>
        {
          roles.canCreate &&
          <div className={cx(styles.field, '-mt-4')}>
            <div />
            <div>
              <a onClick={() => toggleInsuranceNetworkCreateForm()}>Or create a new Insurance Network</a>
            </div>
          </div>
        }
      </div>
    </div>
  );
};

InsuranceNetworkSearch.propTypes = insuranceNetworkSearch;

export default InsuranceNetworkSearch;
